<template>
  <search-group :title="'房源查询'" :span="24" :btnOffset="20" :multipleLines="true"   @search="findData" @clear="clearValue" :inline="true" >
    <Row class="mb16" :gutter="16">
      <Col span="4">
        <Select v-model="searchData.projectCooperationModel" placeholder="项目类型" @on-change="changeType">
          <Option value=''>请选择</Option>
          <Option v-for="item in cooperationModeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.projectFid" placeholder="项目名称" @on-change="changeProject">
          <Option value=''>{{ searchData.projectCooperationModel===''? '请先选择项目类型':(projectList.length!==0 ?'请选择':'暂无数据')}}</Option>
          <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.houseBuildingFid" placeholder="楼栋" @on-change = "changBuiding">
          <Option value=''>请选择</Option>
          <Option v-for="item in buildingList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.houseFloorNumber" placeholder="楼层">
          <Option value=''>请选择</Option>
          <Option v-for="item in floorList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.houseTypeFid" placeholder="房型名称">
          <Option value=''>请选择</Option>
          <Option  v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.stockStatus" placeholder="房源状态" :disabled="searchData.stockRentType===1">
          <Option value=''>请选择</Option>
          <Option v-for="item in stockStatusEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
    <Row :gutter="16">
      <Col span="4">
        <Select v-model="searchData.stockRentType" placeholder="出租类型" @on-change="changeRentType">
          <Option value=''>房源统计</Option>
          <Option value="100" v-for="item in stockRentTypeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.stockIsUnder" placeholder="上架状态">
          <Option value=''>请选择</Option>
          <Option value="100" v-for="item in stockIsUnderEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="searchData.stockIsShow" placeholder="是否显示" :disabled="searchData.stockRentType===1">
          <Option value=''>请选择</Option>
          <Option value="100" v-for="item in stockIsShowEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Row :gutter="16">
          <Col span="8">
            <Input :class="{'ivu-form-item-error':minError}" type="text" v-model="searchData.minStockArea" @on-blur="validateArea($event,searchData.minArea,true)"></Input>
          </Col>
          <Col span="8" style="line-height:32px; text-align:center; padding:0">
            <span>&lt;面积&lt;</span>
          </Col>
          <Col span="8">
            <Input :class="{'ivu-form-item-error':maxError}" type="text" v-model="searchData.maxStockArea" @on-blur="validateArea($event,searchData.maxArea,false)"></Input>
          </Col>
        </Row>
        <div v-if="minError||maxError" class="error-tip">请输入大于0的数字</div>
      </Col>
      <Col span="4">
        <Input type="text" v-model="searchData.stockNumber" placeholder="按房间号搜索" @keyup.enter.native="findData"></Input>
      </Col>
    </Row>
  </search-group>
</template>

<script type="text/ecmascript-6">

  import SearchGroup from 'components/SearchGroup/index';
  import { projectByCooperationMode, getHouseType } from "api/house"
  export default {
    props:{
      // 统计类型
      stockRentTypeEnums:{
        type:Array,
        default:[]
      },
      stockStatusEnums:{
        type:Array,
        default:[]
      },
      stockIsShowEnums:{
        type:Array,
        default:[]
      },
      // 项目类型
      cooperationModeEnums:{
        type:Array,
        default:[]
      },
      stockIsUnderEnums:{
        type:Array,
        default:[]
      },
      buildInfoList:{
        type:Array,
        default:[]
      }

    },
    watch:{
      cooperationModeEnums(val){
        this.searchData.projectCooperationModel = val[0].value
      }
    },
    components: {
       // SearchGroup
    },
    data () {
      return {
        loading:false,
        searchData:{
          projectCooperationModel:'',
          projectTypeFid:'',
          houseBuildingFid: '',
          houseFloorNumber: '',
          houseTypeFid: '',
          maxStockArea: '',
          minStockArea: '',
          projectFid: '',
          stockIsShow: '',
          stockIsUnder: '',
          stockNumber: '',
          stockRentType:'',
          stockStatus: '',
          limit: 10,
          page: 1
        },
        projectList:[],
        houseTypeList:[],
        buildingList:[],
        floorList:[],
        roomList:[],
        roomNumber:'',
        minError:false,
        maxError:false
      }
    },
    methods: {
      findData() {
        this.$emit('findData', this.searchData);
      },
      clearValue() {
        for(let key in  this.searchData){
          if(key==='page' || key==='limit') continue
          if(key === 'status') this.searchData[key] = 0
          this.searchData[key]=''
        }
      },
      changeType(value) {
        if(value === ''){
          this.projectList=[]
          this.buildingList = []
          this.floorList =[]
          this.houseTypeList=[]
        }
        projectByCooperationMode(value).then( res => {
          this.projectList = res.data;
        })
      },
      changeRentType(val){
        if(val === 1) {
          this.searchData.stockStatus = ''
          this.searchData.stockIsShow = ''
        }
      },
      changeProject(value) {
        if(value === '') {
          this.buildingList = []
          this.houseTypeList = []
        }else{
          getHouseType(value).then(res => {
            this.houseTypeList = res.data.houseTypeList;
          })
          let project = this.buildInfoList.find( item => {
            return item.value === value
          })
          if(project === undefined) {
            this.$Message.error('获取楼栋信息错误');
          } else {
            this.buildingList = project.children
          }
        }
      },
      changBuiding(value) {
        if(!this.searchData.houseBuildingFid){
          this.floorList=[]
          return
        }
        for (let [index, item] of this.buildingList.entries()) {
          if (value === item.value) {
            this.floorList = this.buildingList[index].children;
          }
        }
      },
      validateArea(event,area,isMin) {
        const pattern = /^(?:[1-9][0-9]*\.[0-9]+|0\.(?!0+$)[0-9]+|[1-9]+\d*)$/
        if(pattern.test(event.target.value)||event.target.value===''){
          if(event.target.value===''){
            area = ''
          }
          isMin?this.minError = false :this.maxError=false
        }else {
          isMin?this.minError = true :this.maxError=true

        }
      }
    }
  }
</script>
<style scoped>
  .error-tip {
    position: absolute;
    color: #F56356;
  }
</style>

